<template>
  <v-dialog v-model="dialog" width="unset">
    <v-card>
      <v-card-title class="headline">Nezaradené produkty do výroby</v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selectedItems"
          :headers="orderDetailsTableHeader"
          :items="unprocessedOrderDetails"
          item-key="orderDetailId"
          show-select
          class="elevation-0 transparent"
          dense
        ></v-data-table>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" text @click="addItems()">
          <v-icon left>mdi-plus</v-icon>Pridaj
        </v-btn>
        <v-btn color="warning" text @click="dialog = false">Zatvor</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UnitOfWorkService from "@/services/UnitOfWorkService";
import { orderDetailsTableHeader } from "@/views/manufacturing_command/js/tableHeaders";

export default {
  name: "OrderDetailsTable",
  props: {
    loadDefaulValues: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    selectedItems: [],
    unprocessedOrderDetails: [],
    orderDetailsTableHeader: orderDetailsTableHeader
  }),

  created() {
    if (this.loadDefaulValues) this.initialize();
  },

  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      new UnitOfWorkService()
        .orderService()
        .getUnprocessedOrderDetails()
        .then(response => {
          this.unprocessedOrderDetails = response.data;
          this.dialog = true;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    openDialog() {
      this.initialize();
    },

    addItems() {
      this.$emit("selected-items", this.selectedItems);
      this.selectedItems = [];
      this.dialog = false;
    }
  }
};
</script>
